import React from 'react';

const BS_Navbar = () => {
    return (
        <div>
            <h1>BS_Navbar Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Navbar;
